import { EnumFiscalResidence } from '@blank/api'
import { CountryConfig, EnumHomeCountryCode } from '../../types'

export const LCL_FR_COUNTRY_CONFIG: CountryConfig = {
  canAddCompanyDataManually: false,
  companyIdentificationNumberLength: 9,
  shouldChooseDomiciliationOnSignup: false,
  isBeta: false,
  canAddEnterpriseMandate: true,
  shouldDisplayUserFeedbackButton: false,
  isSponsorshipEnabled: false,
  increaseTransferLimitTypeformId: 'F1ZNqG4K',
  feedbackTypeformId: '',
  accountClosingTypeformId: 's9Gl6AyP',
  shouldDisplayAdditionalTouOnSelectOffer: false,
  fiscalResidenceOptions: [EnumFiscalResidence.FRA, EnumFiscalResidence.USA],
  homeCountryCode: EnumHomeCountryCode.FRA,
  invoicing: {
    canCreateEstimateDocument: true,
    canAddFiscalTaxesToDocument: false,
    canAddFiscalStampToDocument: false,
    shouldSelectVATExonerationCode: false,
  },
  shouldDisplayAverageBalanceDocuments: false,
  shouldBuildMicroEnterpriseCreationURLWithParams: true,
  whatsAppSupportNumber: undefined,
  shouldCustomizeCardFraudInsuranceRedirectionUrl: false,
  fileComplaintTypeformId: 'HTgT6MEO',
  shouldDisplayZendeskMessagingWidget: false,
  zendeskScriptKey: '',
  hasOptionalConsents: false,
}
